import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/domains/new/loading';

export const Route = createFileRoute('/_private/domains/new')({
  pendingComponent: Loading,
});
